<section class="content-header" style="padding: 0.5% !important;">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-md-6">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item">
            <a [routerLink]="['/admin/']"
              ><i class="fas fa-home"></i> &nbsp;Trang chủ</a
            >
          </li>
          <li class="breadcrumb-item active">Kê khai sinh hoạt cộng đồng</li>
        </ol>
      </div>
      <div class="col-md-6">
        <button
          class="btn btn-success btn-sm"
          (click)="open(ThemModal, 'xl', 'Add', '')"
          style="float: right;"
        >
          <i class="fas fa-plus-circle"></i> Thêm mới
        </button>
      </div>
    </div>
  </div>
</section>

<section class="content cus-body">
  <div class="card">
    <div class="card-body">
      <div class="tab-content">
        <div class="active tab-pane">
          <div
            class="table-responsive"
            style="max-height: 60vh; margin-bottom: 15px;"
          >
            <table class="table table-bordered">
              <thead>
                <th class="text-center">Tên hoạt động</th>
                <th class="text-center">Mô tả</th>
                <th class="text-center">Thời gian</th>
                <th class="text-center">Điểm</th>
                <th class="text-center">Minh chứng</th>
                <th class="text-center">Ghi chú</th>
                <th class="text-center">Trạng thái</th>
                <th class="text-center">Thao tác</th>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let data of dataTable
                      | paginate: { itemsPerPage: 10, currentPage: page }
                  "
                >
                  <td>{{ data.Ten_hoat_dong }}</td>
                  <td>{{ data.Mo_ta }}</td>
                  <td>{{ data.Thoi_gian }}</td>
                  <td>{{ data.Diem }}</td>
                  <td class="text-center">
                    <a href="{{ data.URL_minh_chung }}" download target="_blank"
                      ><i class="fas fa-download"></i
                    ></a>
                  </td>
                  <td>{{ data.Ghi_chu }}</td>
                  <td class="text-center" *ngIf="data.Trang_thai == 0">
                    <p>Khởi tạo</p>
                  </td>
                  <td class="text-center" *ngIf="data.Trang_thai == 1">
                    <p class="text-success">Đã duyệt</p>
                  </td>
                  <td class="text-center" *ngIf="data.Trang_thai == 2">
                    <p class="text-danger">Từ chối</p>
                  </td>
                  <td class="text-center" *ngIf="data.Trang_thai == 3">
                    <p class="text-danger">Đã sửa</p>
                  </td>
                  <td class="text-center">
                    <button
                      class="btn btn-sm btn-warning"
                      (click)="open(ThemModal, 'xl', 'Edit', data)"
                      style="margin-right: 7px;"
                    >
                      <i class="fas fa-edit" title="Sửa"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-danger"
                      (click)="open(DeleteModal, '', 'Delete', data)"
                      style="margin-right: 7px;"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="dataTable.length == 0">
                  <td colspan="7" class="text-center">Không có kết quả</td>
                </tr>
              </tbody>
            </table>
            <pagination-controls
              class="float-right"
              (pageChange)="page = $event"
              previousLabel="Trước"
              nextLabel="Sau"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-template #ThemModal let-modal>
  <div
    class="modal-header m-header text-center"
    style="padding-top: 0px; padding-bottom: 0px;"
  >
    <h4 class="modal-title h-title w-100">{{ titleModal }}</h4>
    <span
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
      style="font-size: 25px;"
      >&times;</span
    >
  </div>
  <div class="modal-body" style="margin-top: 5px; padding-top: 5px;">
    <form class="form-horizontal" [formGroup]="Action">
      <div class="row" style="font-family: sans-serif;">
        <div class="col-md-12">
          <label class="col-md-10 require">Tên hoạt động</label>
          <input
            class="form-control"
            required
            placeholder="Nhập Tên hoạt động"
            type="text"
            formControlName="Ten_hoat_dong"
            [ngClass]="{
              'is-invalid': submitted && checkvalue.Ten_hoat_dong.errors
            }"
          />
          <div
            *ngIf="submitted && checkvalue.Ten_hoat_dong.errors"
            class="invalid-feedback"
          >
            <div *ngIf="checkvalue.Ten_hoat_dong.errors.required">
              Tên hoạt động không được bỏ trống!
            </div>
            <div *ngIf="checkvalue.Ten_hoat_dong.errors.maxlength">
              Tên hoạt động tối đa 500 ký tự!
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <label class="col-md-10 require">Mô tả</label>
          <textarea
            cols="100"
            rows="4"
            class="form-control"
            placeholder="Mô tả"
            formControlName="Mo_ta"
          >
          </textarea>
          <div
            *ngIf="submitted && checkvalue.Mo_ta.errors"
            class="invalid-feedback"
          >
            <div *ngIf="checkvalue.Mo_ta.errors.required">
              Mô tả không được bỏ trống!
            </div>
            <div *ngIf="checkvalue.Mo_ta.errors.maxlength">
              Mô tả tối đa 500 ký tự!
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label class="col-md-10 require">Thời gian</label>
          <input
            class="form-control"
            required
            placeholder="Nhập thời gian"
            type="text"
            formControlName="Thoi_gian"
            [ngClass]="{
              'is-invalid': submitted && checkvalue.Thoi_gian.errors
            }"
          />
          <div
            *ngIf="submitted && checkvalue.Thoi_gian.errors"
            class="invalid-feedback"
          >
            <div *ngIf="checkvalue.Thoi_gian.errors.required">
              Thời gian không được bỏ trống!
            </div>
            <div *ngIf="checkvalue.Thoi_gian.errors.maxlength">
              Thời gian tối đa 100 ký tự!
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label class="col-md-10 require">Điểm</label>
          <input
            class="form-control"
            required
            placeholder="Nhập thời gian"
            type="number"
            formControlName="Diem"
            [ngClass]="{
              'is-invalid': submitted && checkvalue.Diem.errors
            }"
          />
          <div
            *ngIf="submitted && checkvalue.Diem.errors"
            class="invalid-feedback"
          >
            <div *ngIf="checkvalue.Diem.errors.min">
              Điểm phải lớn hơn 0
            </div>
            <div *ngIf="checkvalue.Diem.errors.required">
              Điểm không được bỏ trống!
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label class="col-md-10">Tên file:</label>
          <input class="form-control" formControlName="Url_minhchung" />
        </div>
        <div class="col-md-6">
          <label class="col-md-10 require">File minh chứng</label>
          <input (change)="Uploadfile($event)" type="file" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="float-right">
      <button type="button" class="btn btn-md btn-success" (click)="onSubmit()">
        <i class="fa-plus-circle fas"></i> Lưu
      </button>
      <button
        type="button"
        class="btn btn-md btn-danger"
        (click)="modal.dismiss('Cross click')"
        style="margin-left: 1em;"
      >
        <i class="far fa-times-circle"></i> Đóng
      </button>
    </div>
  </div>
</ng-template>
<ng-template #DeleteModal let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="icon-box">
        <i
          class="fas fa-trash-alt"
          style="
            color: #f15e5e;
            font-size: 46px;
            display: inline-block;
            margin-top: 13px;
          "
        ></i>
      </div>
      <p
        style="
          color: inherit;
          text-decoration: none;
          font-size: 20px;
          text-align: center;
          font-weight: 600;
          margin-top: 3em;
        "
      >
        Bạn có chắc chắn muốn xóa
      </p>
      <div class="text-center">
        <button type="button" class="btn btn-md btn-success" (click)="Delete()">
          Đồng ý
        </button>
        <button
          type="button"
          class="btn btn-md btn-danger"
          (click)="modal.dismiss('Cross click')"
          style="margin-left: 1em;"
        >
          Hủy bỏ
        </button>
      </div>
    </div>
  </div>
</ng-template>
